import {
  TableCellProps,
  WbEntityRefLink,
  WbEntityRefLinks,
  WbTooltip,
  WbTruncatedTypographyWrapper,
} from '@agilelab/plugin-wb-platform';
import { Entity, RELATION_OWNED_BY } from '@mainstage/catalog-model';
import { OverflowTooltip } from '@mainstage/core-components';
import { getEntityRelations } from '@mainstage/plugin-catalog-react';
import { Typography } from '@material-ui/core';

export const createEntityRefColumn = (options: {
  defaultKind?: string;
}): TableCellProps<any> => {
  const { defaultKind } = options;

  return {
    headerName: 'Name',
    uniqueFieldId: 'entityRef',
    sortable: true,
    field: 'metadata',
    fieldRender: entity => (
      <WbEntityRefLink
        entityRef={entity}
        defaultKind={defaultKind}
        title={entity.metadata?.title}
      />
    ),
  };
};

export const createNameColumn = (): TableCellProps<any> => {
  return {
    headerName: 'Name',
    uniqueFieldId: 'name',
    field: 'spec',
    width: '30%',
    fieldRender: e => {
      const title = e.metadata?.name || e.spec?.mesh?.name;

      return (
        <WbTooltip placement="bottom-start" title={title!}>
          <Typography>{title}</Typography>
        </WbTooltip>
      );
    },
  };
};

export const createOwnerColumn = (): TableCellProps<Entity> => {
  return {
    headerName: 'Owner',
    uniqueFieldId: 'owner',
    field: 'spec',
    width: '30%',
    fieldRender: e => (
      <WbEntityRefLinks
        entityRefs={getEntityRelations(e, RELATION_OWNED_BY)}
        defaultKind="group"
      />
    ),
  };
};

export const createSpecTypeColumn = (): TableCellProps<Entity> => {
  return {
    headerName: 'Type',
    uniqueFieldId: 'specType',
    field: 'spec',
    fieldRender: e => (
      <Typography
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {e?.spec?.type as string | undefined}
      </Typography>
    ),
    width: '15%',
  };
};

export const createSpecLifecycleColumn = (): TableCellProps<Entity> => {
  return {
    headerName: 'Lifecycle',
    uniqueFieldId: 'specLifecycle',
    field: 'spec',
    fieldRender: e => (
      <Typography
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {e?.spec?.lifecycle as string | undefined}
      </Typography>
    ),
  };
};

export const createMetadataDescriptionColumn = (): TableCellProps<Entity> => {
  return {
    headerName: 'Description',
    uniqueFieldId: 'metadataDescription',
    field: 'metadata',
    fieldRender: entity => (
      <OverflowTooltip
        text={entity.metadata.description}
        placement="bottom-start"
        line={2}
      />
    ),
  };
};

export const createDescColumn = (): TableCellProps<Entity> => {
  return {
    headerName: 'Description',
    uniqueFieldId: 'description',
    field: 'kind',
    width: '40%',
    fieldRender: e => (
      <WbTruncatedTypographyWrapper value={e.metadata.description ?? ''} />
    ),
  };
};
